import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Container,
} from "@mui/material";
import farmManagementCard from "../../assets/landing/images/farm-management-card.png";
import decarbonizationProgramCard from "../../assets/landing/images/decarbonization-program-card.png";
import iotPoweredSoilTesting from "../../assets/landing/images/iot-powered-soil-testing.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const AgriTechSection = () => {
  const { t } = useTranslation();
  return (
    <Container sx={{ my: 4 }}>
      {/* Hero Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ maxWidth: "35%" }}>
          <Typography variant="h3" sx={{ fontWeight: "bold" }}>
            {t("Join the Agri-Tech Revolution")}
          </Typography>
        </Box>

        <Box sx={{ maxWidth: "40%" }}>
          <Typography fontSize={"1.125rem"} color="#A6A6A6" sx={{ mb: 2 }}>
            {t(
              "Be part of a future where technology meets tradition, ensuring profitability, sustainability, and efficiency for every farmer."
            )}
          </Typography>
        </Box>

        <Link to="/signup">
          <Button
            variant="contained"
            sx={{
              bgcolor: "#54BD95",
              borderRadius: 28,
              color: "white",
              px: 4,
              py: 1.5,
              "&:hover": {
                bgcolor: "#3D8B76",
              },
              textTransform: "none",
            }}
          >
            {t("Get Started")}
          </Button>
        </Link>
      </Box>

      {/* Feature Cards */}
      <Grid container spacing={5.5} sx={{ mt: 0 }}>
        {/* Farm Management Card */}
        <Grid
          item
          md={4}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <img src={farmManagementCard} width="100%" />
          <Typography
            fontSize="1.875rem"
            sx={{ mt: 2, fontWeight: "bold", flexGrow: 1 }}
          >
            {t("Farm Management")}
          </Typography>
          <Typography fontSize="1.125rem" color="#A6A6A6">
            {t("Here you can handle Farm with FarmApp Digital")}
          </Typography>
        </Grid>

        {/* Decarbonization Program Card */}
        <Grid
          item
          md={4}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <img src={decarbonizationProgramCard} width="100%" />
          <Typography
            fontSize="1.875rem"
            sx={{ mt: 2, fontWeight: "bold", flexGrow: 1 }}
          >
            {t("Decarbonization program")}
          </Typography>
          <Typography fontSize="1.125rem" color="#A6A6A6">
            {t("Here you can handle Farm with FarmApp Digital")}
          </Typography>
        </Grid>

        {/* IoT-Powered Soil Testing Card */}
        <Grid
          item
          md={4}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <img src={iotPoweredSoilTesting} width="100%" />
          <Typography
            fontSize="1.875rem"
            sx={{ mt: 2, fontWeight: "bold", flexGrow: 1 }}
          >
            {t("IoT-Powered Soil Testing")}
          </Typography>
          <Typography fontSize="1.125rem" color="#A6A6A6">
            {t("Here you can handle Farm with FarmApp Digital")}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AgriTechSection;
